import { render } from "./Batches.vue?vue&type=template&id=13bee046"
import script from "./Batches.vue?vue&type=script&lang=js"
export * from "./Batches.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__